import { useCss } from 'app/utils/css';
import React, { FunctionComponent } from 'react';

const CallModalMascot: FunctionComponent = ({ children }) => {
  const css = useCss();
  return (
    <div
      className={css('container', {
        margin: '0 auto',
        maxWidth: '200px',
        minWidth: '80px',
        width: '33%',
      })}
    >
      {children}
    </div>
  );
};

export default CallModalMascot;
